import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
export default defineComponent({
    name: 'blue-cart-indicator',
    computed: Object.assign({}, mapGetters('blue', ['isCartFilled'])),
});
